import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";

export default function CTAFinalSection() {
  return (
    <section className="py-24 md:py-32 bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-4xl mx-auto text-center"
        >
          <ShieldCheck size={40} className="text-primary mx-auto mb-6" />

          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.95] mb-6">
            <span className="text-foreground">Faça parte do</span>
            <br />
            <span className="text-primary">funcional fitness oficial.</span>
          </h2>

          <p className="text-muted-foreground text-base sm:text-lg max-w-xl mx-auto mb-10 leading-relaxed">
            Filie-se à FPF3 e tenha acesso ao ranking oficial, competições
            regulamentadas e toda a estrutura da federação.
          </p>

          <Link
            to="/filiacao"
            className="inline-flex items-center justify-center px-10 py-5 bg-primary text-primary-foreground font-bold uppercase tracking-[0.15em] text-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_0_40px_hsl(0_100%_42%/0.4)] min-h-[56px]"
          >
            Filiar-se Agora
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
